import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { InspirationMainCategoryDefinition, InspirationTheme } from '../../lib/inspiration';
import LogoWhiteT from '../../assets/LogoWhiteT.png';
import SideBarMainCategory from './SideBarMainCategory';

import { DeviceQueries } from 'Common/src/components/styled';

const SideBar = ({ mainCategories, theme, onThemeClick, onCreateClick, mobileShown, onClose }: {
  mainCategories: InspirationMainCategoryDefinition[],
  theme?: InspirationTheme;
  mobileShown: boolean;
  onThemeClick: (theme: InspirationTheme) => void;
  onCreateClick: () => void;
  onClose: () => void;
}) => {
  const navigate = useNavigate();

  const onLogoClick = () => {
    navigate('/');
  };

  return <>
    <MobileMask onClick={onClose} $mobileShown={mobileShown}/>
    <Bar $mobileShown={mobileShown}>
      <LogoWrapper onClick={onLogoClick}>
        <img src={LogoWhiteT} width={150} height={50}/>
      </LogoWrapper>

      <Header>
        Categories
      </Header>

      <CategoryGroup>
        {
          mainCategories.map(mainCat => <SideBarMainCategory
            key={mainCat.id}
            mainCat={mainCat}
            selectedTheme={theme}
            onThemeClick={onThemeClick}
          />)
        }
      </CategoryGroup>

      <Footer>
        <Divider/>
        <CreateLink onClick={onCreateClick}>Create your own</CreateLink>
      </Footer>
    </Bar>
  </>;
};

const MobileMask = styled.div<{ $mobileShown: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.28);
  z-index: 15;
  cursor: pointer;

  ${({ $mobileShown }) => $mobileShown ? '' : 'display: none;'} @media not (${DeviceQueries.mobile}) {
  display: none;
}
`;

const Bar = styled.div<{ $mobileShown: boolean }>`
  max-width: 260px;
  min-width: 260px;

  display: flex;
  flex-direction: column;
  border-right: 1px solid #DFE1E7;
  z-index: 20;
  background-color: var(--sp-bg-color);


  @media (${DeviceQueries.mobile}) {
    ${({ $mobileShown }) => $mobileShown ? '' : 'display: none;'}
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
`;

const LogoWrapper = styled.div`
  margin: 20px;
`;

const Header = styled.h3`
  color: var(--sp-text-color2);
  font-size: 18px;
  font-weight: 600;
  line-height: 155%; /* 27.9px */
  letter-spacing: -0.18px;
  margin: 0 20px;
`;

const CategoryGroup = styled.ul`
  list-style-type: none;
  padding: 0 20px;
  overflow-y: scroll;
  position: relative;
`;

const Footer = styled.div`
  padding: 0 20px;
`;

const Divider = styled.hr`
  width: 100%;
  margin-bottom: 30px;
  border: 0;
  border-bottom: 1px solid #DFE1E7;
`;

const CreateLink = styled.div`
  cursor: pointer;
`;

export default SideBar;
